import { Spin, notification } from 'antd';

import React from 'react';
import { loginConfigurationRepository } from './AuthenticationRepository';
import { AxiosError } from 'axios';
import { AppUser } from 'models/AppUser';
import { GlobalState } from 'core/config';
import { setGlobal } from 'reactn';
import authenticationService from 'services/AuthenticationService';
import Cookies from 'js-cookie';
import { LOGIN_ROUTE, PPF_ROUTE } from 'config/route-consts';
import { useHistory } from 'react-router';

import qs from 'qs';
import { getParameterByName } from 'core/helpers/query';

export default function LoginSSOWaitingPage() {
  const [firstLoad, setFirstLoad] = React.useState<boolean>(true);
  const history = useHistory();
  if (firstLoad) {
    const { code, session_state } = qs.parse(
      window.location.search.substring(1),
    );
    if (code && session_state) {
      const info = {
        usename: undefined,
        password: undefined,
        authorizationCode: code,
        loginConfigurationId: Number(
          localStorage.getItem('loginConfigurationId'),
        ),
      };
      loginConfigurationRepository.login(info).then(res => {
        Cookies.set('accessToken', res?.accessToken);
        authenticationService
          .checkAuth()
          .then((user: AppUser) => {
            setGlobal<GlobalState>({
              user,
            });
            localStorage.setItem('I18N_LANGUAGE', user?.language?.code || 'en');
          })
          .then(() => {
            const savedRedirect = sessionStorage.getItem('postLoginRedirect');
            sessionStorage.removeItem('postLoginRedirect');
            const redirect =
              savedRedirect || getParameterByName('redirect') || PPF_ROUTE;
            if (typeof redirect === 'string' && redirect.startsWith('/ppf')) {
              window.location.href = redirect;
              return;
            }
            if (typeof redirect === 'string' && redirect.startsWith('http')) {
              window.location.href = redirect;
              return;
            }
            history.push(redirect);
          })
          .catch((error: AxiosError<any>) => {
            notification.error({
              message: 'Login failed',
              description: error?.message,
              placement: 'bottomRight',
            });
            history.push(LOGIN_ROUTE);
          });
        setFirstLoad(false);
      });
    }
  }
  return (
    <div className="login-sso-waiting-page">
      <Spin spinning={true}></Spin>
    </div>
  );
}
